import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import EditorToolbar, {
  modules,
  formats,
} from "../../cpn/common/editorToolbar";
import {
  Varchar,
  Char,
  Text,
  Int,
  DateInput,
  TimeInput,
  DateTimeInput,
  Decimal,
  Bool,
  DataEmail,
  DataPhone,
  FileImage,
  FileImageUpdate,
} from "../inputs";
import {
  ClassicEditor,
  AccessibilityHelp,
  Autosave,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  SelectAll,
  Undo,
  FontSize,
  FontFamily,
  NumberedList,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
import { LoadingIcon } from "../../Icons/loading.icon";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { parseTypeWithDefaultValue } from "../../utils/parseType";
import { removeData } from "jquery";
import { Conditions } from "../../utils/Conditions";

export default ({ isData = {} }) => {
  const {
    stringifiedParams,
    urlData,
    isModal,
    handleCloseModal,
    setRefreshPage,
    pageId,
  } = isData;

  const dispatch = useDispatch();
  const { id_str } = useParams();
  const _token = localStorage.getItem("_token");
  const { project_id, version_id, url } = useParams();
  let navigate = useNavigate();
  const { proxy, pages, lang, socket, functions, database, auth } = useSelector(
    (state) => state
  );
  const [api, setApi] = useState({});
  const [tables, setTables] = useState([]);
  const [keyFields, setKeyFields] = useState([]);
  const [params, setParams] = useState([]);
  const [fields, setFields] = useState([]);
  const [data, setData] = useState({});
  const [relatedTables, setRelatedTables] = useState([]);
  const [initialData, setInitData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [page, setPage] = useState(null);
  const [isCurrentPage, setCurrentPage] = useState(undefined);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [isBulkUpdate, setBulkUpdate] = useState(true);
  const removeSelected = useRef([]);
  const [isDataDelete, setDataDelete] = useState([]);
  const [isToggleModal, setIsToggleModal] = useState({
    state: false,
    content: "",
  });
  // const [isDataDelete, setDataDelete] = useState([]);

  // console.log(fields)
  // console.log(initialData)
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get("myParam");
  const checkIdStr = id_str ? id_str : isData.id_str;

  const goToHomePage = () => {
    // navigate(`/page/${url}`);
    navigate(-1);
  };
  const _table = functions.findTableByUrl(page, checkIdStr, "update");

  const [phoneError, setPhoneError] = useState(false);
  const handlePhoneError = (error) => {
    setPhoneError(error);
  };
  const [emailError, setEmailError] = useState(false);
  const handleEmailError = (error) => {
    setEmailError(error);
  };
  // console.log(pages)

  // const result = pages?.filter(item => item.type !== "apiview").find(item => {
  //     // Lấy id từ api_get
  //     const api_get_id = item.components?.[0]?.api_put.split('/')[2];
  //     // So sánh với id_str
  //     return api_get_id === id_str;
  // });

  useEffect(() => {
    if (pages && pages.length > 0) {
      const result = functions.findPageById(pages, `${url}`);
      if (result?.component?.length > 0) {
        setPage(result);
      } else {
      }
    }
  }, [pages, url]);

  const result = functions.findPutApi(page);

  const changeTrigger = (field, value) => {
    if (loaded) {
      const newData = data;
      const newInitialData = initialData;
      if (value === "true") {
        newData[field.fomular_alias] = true;
      } else if (value === "false") {
        newData[field.fomular_alias] = false;
      } else {
        if (typeof value === "string") {
          value = value.trim();
        }
        if (!Array.isArray(field)) {
          newData[field?.fomular_alias || field] = value;
          newInitialData[field?.fomular_alias || field] = value;
        } else {
          newData[value.id] = [...field];
          PUBLIC_API.current[value.id] = value;

          // if (!newData[value.id]) {
          //   newData[value.id] = [...field];
          //   // newData[value.id] = [];
          // } else {
          //   newData[value.id] = [...field]
          //   const filterData =
          //     removeSelected.current &&
          //     removeSelected.current.length > 0 &&
          //     newData[value.id].filter(
          //       (f) =>
          //         !removeSelected.current.some((item) => item._id === f._id)
          //     );

          //   if (filterData.length > 0) {
          //     newData[value.id] = filterData;
          //   } else {
          //     if (!newData[value.id].some((item) => item._id === field._id)) {

          //       newData[value.id] = [...field];
          //     }
          //     // newData[value.id] = [...field];
          //   }
          // }
        }
      }
      console.log("newDatanewData", newData);
      setInitData(newInitialData);
      setData(newData);
    }
  };

  const nullCheck = (data) => {
    let valid = true;

    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      const { NULL, fomular_alias, title: { visible } = {} } = field;

      if (!NULL && visible) {
        if (
          data[fomular_alias] == null ||
          data[fomular_alias] == undefined ||
          data[fomular_alias] === ""
        ) {
          valid = false;
        }
      }
    }
    return { valid };
  };

  let isMapping = useRef(false);

  useEffect(() => {
    const result = functions.findPageById(pages, `${pageId ? pageId : url}`);
    let findId = null;

    result?.component.map((item) => {
      if (item.name === "grid" && item.children && item.children.length > 0) {
        const foundChild = item?.children.find(
          (child) => child?.props?.buttons?.update?.api?.api_id === checkIdStr
        );
        if (foundChild) {
          findId = foundChild?.id;
        }
      } else if (item?.props?.buttons?.update?.api?.api_id === checkIdStr) {
        findId = item.id;
      }
    });

    if (findId && findId.length > 0) {
      const currentPage = pages.find((p) => p.block === findId)?.component?.[0]
        ?.children;
      if (currentPage) {
        setCurrentPage(currentPage);
      }
    }

    // const currentPage = pages.find(
    //   (p) =>
    //     p.block ===
    //     result?.component.find(
    //       (item) => item?.props?.buttons?.update?.api?.api_id
    //     )?.id
    // )?.component?.[0]?.children;
    // setCurrentPage(currentPage);
    if (fields && fields.length > 0) {
      if (isMapping.current === false && isCurrentPage) {
        setFields((prev) => {
          return prev.map((item) => {
            const found_field = isCurrentPage?.find(
              ({ props: { field_id } }) => field_id === item.id
            );

            return { ...item, ...(found_field?.props || {}) };
          });
        });
        isMapping.current = true;
      }
    }
  }, [pages, url, fields, checkIdStr, urlData]);

  if (isToggleModal.state) {
    Swal.fire({
      title: lang["fail"],
      text: isToggleModal.content,
      icon: "error",
      showConfirmButton: true,
      timer: 0,
    });
    setIsToggleModal({ state: false, content: "" });
  }

  useEffect(() => {
    const url = window.location;
    const rawParams = url.pathname.split(`/${id_str}/`)[1];
    const rawUrl = urlData?.split(`/${checkIdStr}/`)[1];
    const checkRawParams = rawParams
      ? rawParams?.split("/")
      : rawUrl?.split("/");
    const paramsList = checkRawParams;
    setParams(paramsList?.[0]);
    if (isCurrentPage) {
      fetch(`${proxy()}/apis/api/${checkIdStr}/input_info`, {
        headers: {
          Authorization: _token,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const { success, data } = res;
          const currentPage = pages.find(
            (p) =>
              p.block ===
              result?.component?.find(
                (item) => item?.props?.buttons?.add?.api?.api_id === checkIdStr
              )?.id
          )?.component?.[0]?.children;
          if (success) {
            // const { tables } = data.tables;
            // const apiFields = data.params;
            const apiFields = data.body;
            // apiFields.push(...data.body);
            const fields = [];
            isCurrentPage.map(({ props: { field_id, ...props } }) => {
              const found_field = apiFields?.find(({ id }) => field_id === id);
              if (found_field) {
                fields.push({ ...found_field, ...props });
              }
            });
            const serializeParams = apiFields.map((param, index) => {
              const { fomular_alias } = param;
              return { fomular_alias, value: paramsList?.[index] };
            });
            const keyFields = serializeParams.map((par) => {
              const field = apiFields.filter(
                (f) => f.fomular_alias == par.fomular_alias
              )[0];
              return field;
            });
            setKeyFields(keyFields);
            setApi(data);
            setFields(fields);
            setTables(data.tables);
            setRelatedTables(relatedTables);
            // fetch(`${proxy()}/apis/retrieve/${id_str}/${rawParams}`, {
            fetch(`${proxy()}/apis/retrieve/${checkIdStr}/${checkRawParams}`, {
              headers: {
                Authorization: _token,
              },
            })
              .then((res) => res.json())
              .then((res) => {
                const { data, success } = res;
                if (success) {
                  let initData = data;
                  if (initData[0]) {
                    const data = {};
                    apiFields.map((field) => {
                      const { fomular_alias } = field;
                      data[fomular_alias] = initData[0][fomular_alias];
                    });
                    setInitData(initData[0]);
                    setData({ ...data });
                    setLoaded(true);
                  }
                }
              });
          } else {
            // al.failure("Lỗi", "API này không tồn tại hoặc đã bị vô hiệu")
          }
        });
    }
  }, [pages, isCurrentPage, checkIdStr, urlData]);
  // const [isMapping, setIsMapping] = useState(false);

  const showError = (title, text) => {
    Swal.fire({
      title: title,
      html: text.replace(/\n/g, "<br>"),
      icon: "error",
      showConfirmButton: true,
    });
  };
  const handleAPIErrors = (res) => {
    const { primaryConflict, foreignConflict, typeError } = res;

    if (primaryConflict && foreignConflict)
      return showError(lang["faild"], lang["erorr pk fk"]);
    if (primaryConflict) return showError(lang["faild"], lang["erorr pk"]);
    if (foreignConflict) return showError(lang["faild"], lang["erorr fk"]);
    if (typeError) return showError(lang["faild"], lang["fail.add"]);
  };

  // thinh handleSubmit
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    submit(event); // Call your submit function
  };
  // console.log(fields)
  let PUBLIC_API = useRef({});
  let GET_DATA = useRef({});
  const API_DELETE = useRef();
  const submit = async (event) => {
    // setLoadingUpdate(true);
    if (event) {
      event.preventDefault();
    }
    const url = window.location;
    const rawParams = url.pathname.split(`/${checkIdStr}/`)[1];
    const rawUrl = urlData?.split(`/${checkIdStr}/`)[1];
    const checkRawParams = rawParams ? rawParams : rawUrl;
    const paramsList = checkRawParams?.split("/");
    const mappedData = {
      ...data,
    };

    const mapping_fields = [];

    const data_keys = Object.keys(mappedData);

    let API_PAYLOAD = {};

    const { tables: TABLES, fields: FIELDS } = database;
    if (PUBLIC_API.current) {
      for (const index in PUBLIC_API.current) {
        if (PUBLIC_API.current[index].apiPut) {
          const {
            apiPut: {
              api_detail: {
                params,
                body_detail,
                sending_data_type,
                url,
                tables,
                body_update_method,
              },
            },
            id: field_id,
          } = PUBLIC_API.current[index];

          const mapped_tables = {};
          API_PAYLOAD[url] = {};

          for (const index in params) {
            const id = params[index];
            mapping_fields.push(id);
          }

          for (const index in body_detail) {
            const { id, fomular_alias, props } = body_detail[index];

            if (!data_keys.includes(fomular_alias)) {
              mappedData[fomular_alias] = parseTypeWithDefaultValue({
                ...body_detail[index],
                ...props,
              }).result;

              mapping_fields.push(id);
            }
          }

          for (const index in TABLES) {
            const { foreign_keys } = TABLES[index];
            for (const j in foreign_keys) {
              const { field_id, ref_field_id } = foreign_keys[j];
              if (mapping_fields.includes(field_id)) {
                let key, value;
                for (const index in FIELDS) {
                  const field = FIELDS[index];
                  if (field.id === field_id) {
                    key = field.fomular_alias;
                  }
                  if (field.id === ref_field_id) {
                    value = field.fomular_alias;
                  }
                  mappedData[key] = mappedData[value];
                }
              }
            }
          }

          for (const index in tables) {
            const table = TABLES.find((item) => item.id === tables[index]);
            if (table) {
              mapped_tables[table.table_alias] = table;
              API_PAYLOAD[url][table.table_alias] = [];
            }
          }
          for (const k in mapped_tables) {
            const table = mapped_tables[k];

            if (sending_data_type?.[k]?.value === "array") {
              for (const index in data[field_id]) {
                const item = data[field_id][index];
                const payload = {};

                if (item.criteria) {
                  payload.criteria = item.criteria;
                }
                for (const index in body_detail) {
                  const { id, fomular_alias, props } = body_detail[index];

                  let value =
                    mappedData[fomular_alias] ||
                    item[fomular_alias] ||
                    parseTypeWithDefaultValue({
                      ...body_detail[index],
                      ...props,
                    }).result;

                  payload[fomular_alias] = value;
                }
                API_PAYLOAD[url][table.table_alias].push(payload);
              }
            }
          }
        }
      }
    }
    for (const field of fields) {
      const { conditions_api = [], conditions = [] } = field;

      if (data?.[field.fomular_alias] && conditions.length) {
        const requests = [];
        const MAPPED_DATA = {};
        for (const { api: value } of conditions_api) {
          const api = value?.value;
          const params = api?.params;
          const mappedParams = [];
          for (const param of params) {
            mappedParams.push(FIELDS.find((item) => item.id === param));
          }
          let url = api.url;
          for (const param of mappedParams) {
            url += `/${data[param.fomular_alias]}`;
          }

          requests.push(
            fetch(`${proxy()}${url}`, {
              method: api.api_method.toUpperCase(),
            })
          );
        }
        const response = await Promise.all(requests);

        for (const i in response) {
          const res = response[i];
          const label = conditions_api[i].label;
          const { data } = await res.json();
          MAPPED_DATA[label] = data;
        }

        for (const condition of conditions) {
          const {
            conditions: CONDITIONS,
            isBreak,
            successComponents,
            failComponents,
          } = condition;

          for (const cond of CONDITIONS) {
            const {
              left_fields,
              right_fields,
              left_field_position,
              right_field_position,
              operator,
            } = cond;
            const conditionInstance = new Conditions(data, MAPPED_DATA);
            const first_value = conditionInstance.convert(left_fields);
            const second_value = conditionInstance.convert(right_fields);

            let result = conditionInstance.compare(
              { value: first_value, position: left_field_position },
              { value: second_value, position: right_field_position },
              operator.value
            );
            let keysRegex = /\$(variable|from)\([^\)]+\)/g;

            if (first_value === initialData[field.fomular_alias]) {
              result = true;
            }

            if (isBreak && result) {
              let str = successComponents?.[0]?.value || "";

              setIsToggleModal({
                state: true,
                content: str.replace(keysRegex, function (match, p1, p2) {
                  return conditionInstance.convertBuiltInFunc(match);
                }),
              });
              return;
            } else if (!result) {
              let str = failComponents?.[0]?.value || "";

              setIsToggleModal({
                state: true,
                content: str.replace(keysRegex, function (match, p1, p2) {
                  return conditionInstance.convertBuiltInFunc(match);
                }),
              });
              return;
            }
          }
        }
      }
    }

    if (!emailError && !phoneError && nullCheck(data)) {
      fetch(`${proxy()}/ui/${checkIdStr}/${paramsList}`, {
        method: "PUT",
        headers: {
          Authorization: `${_token}`,
          "content-type": "application/json",
        },
        body: JSON.stringify({ ...data }),
      })
        .then((res) => res.json())
        .then(async (res) => {
          // console.log(res)
          if (res?.ERRORS?.length) {
            showError(
              lang["faild"],
              `${res.ERRORS.map((error) => {
                const field = database.fields.find(
                  ({ fomular_alias }) => fomular_alias === error.field
                );
                return `${field.field_name} ${lang[error.type.toLowerCase()]}`;
              })}`
            );
          } else if (
            res.primaryConflict ||
            res.foreignConflict ||
            res.typeError
          ) {
            handleAPIErrors(res);
          } else {
            if (res.content === "403 - Forbidden") {
              Swal.fire({
                title: lang["fail"],
                text: lang["no privileges"],
                icon: "error",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                setLoadingUpdate(false);
              });
            } else if (!res.success) {
              Swal.fire({
                title: lang["fail"],
                text: lang["fail.update"],
                icon: "error",
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              const requests = Object.keys(API_PAYLOAD).map(async (key) => {
                const response = await fetch(`${proxy()}${key}`, {
                  method: "PUT",
                  headers: {
                    Authorization: _token,
                    "content-type": "application/json",
                  },
                  body: JSON.stringify(API_PAYLOAD[key]),
                });
                if (!response.ok) {
                  throw new Error(
                    `PUT request failed for ${key}: ${response.statusText}`
                  );
                }
                return response;
              });

              try {
                await Promise.all(requests);
              } catch (err) {
                console.error("One or more PUT requests failed:", err);
              }

              const requestsDelete = isDataDelete.map(async (param) => {
                const response = await fetch(
                  `${proxy()}${API_DELETE.current.url}/${param}`,
                  {
                    method: "DELETE",
                    headers: {
                      Authorization: _token,
                      "content-type": "application/json",
                    },
                  }
                );
                if (!response.ok) {
                  throw new Error(
                    `DELETE request failed for ${param}: ${response.statusText}`
                  );
                }
                return response;
              });

              try {
                await Promise.all(requestsDelete);
              } catch (err) {
                console.error("One or more DELETE requests failed:", err);
              }

              Swal.fire({
                title: lang["success"],
                text: lang["success.update"],
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                setLoadingUpdate(false);
                if (setRefreshPage !== undefined) {
                  setRefreshPage((prev) => prev + 1);
                }
              });
            }
          }
          const dataSubmit = {
            api_id: checkIdStr,
            data: data,
          };
          socket.emit("/dipe-production-update-data", dataSubmit);
        })
        .catch((error) => {
          // Xử lý lỗi nếu cần
        });
    } else {
      if (emailError) showError(lang["faild"], lang["error.email_invalid"]);
      else if (phoneError)
        showError(lang["faild"], lang["error.phone_invalid"]);
      else showError(lang["faild"], lang["fail.null"]);
    }
  };

  const editorConfig = {
    toolbar: {
      items: [
        "undo",
        "redo",
        "|",
        "heading",
        "|",
        "fontfamily",
        "fontsize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "strikethrough",
        "subscript",
        "superscript",
        "code",
        "|",
        "link",
        "uploadImage",
        "blockQuote",
        "codeBlock",
        "|",
        "bulletedList",
        "numberedList",
        "todoList",
        "outdent",
        "indent",
      ],
      shouldNotGroupWhenFull: false,
    },
    plugins: [
      AccessibilityHelp,
      Autosave,
      Bold,
      Essentials,
      Italic,
      Paragraph,
      SelectAll,
      Undo,
      FontSize,
      FontFamily,
    ],
  };
  if (loadingUpdate) {
    Swal.fire({
      title: lang["Updating data"],
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  if (_table) {
    const table_alias = _table?.source?.tables?.[0]?.table_alias;
    const { ct } = auth;
    for (const index in ct) {
      const item = ct[index];
      if (item?.table_alias === table_alias && !item?.["update"]) {
        return null;
      }
    }
  }

  return (
    <div class="midde_cont" onSubmit={handleSubmit}>
      <div class="container-fluid">
        {!isModal ? (
          <>
            <div class="row column_title">
              <div class="col-md-12">
                <div class="page_title">
                  <h4 class="ml-1">{lang["data management"]}</h4>
                </div>
              </div>
            </div>
            {/* List table */}
            <div class="row">
              <div class="col-md-12">
                <div
                  class="white_shd full margin_bottom_30"
                  style={{ marginBottom: "0" }}
                >
                  <div class="full graph_head_cus d-flex">
                    <div class="heading1_cus margin_0 ">
                      <h5>
                        <label class="pointer" onClick={() => goToHomePage()}>
                          <a title={lang["back"]}>
                            <i class=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link"></i>
                          </a>
                          {functions.findPropsNameUpdateByUrl(page, checkIdStr)}
                          <i
                            class={` ${
                              functions
                                .findPropsNameUpdateByUrl(page, checkIdStr)
                                ?.trim() !== "" &&
                              "fa fa-chevron-right ml-2 mr-1"
                            } `}
                          ></i>
                          {lang["update"]}
                        </label>
                      </h5>
                    </div>
                  </div>
                  <div class="table_section padding_infor_info input_put">
                    <div class="row column1">
                      <div class="form-group col-lg-4"></div>
                      <div class="col-md-12 col-lg-12">
                        <div class="d-flex align-items-center mb-1"></div>
                      </div>
                      {tables.length > 0 ? (
                        <div class="col-md-12">
                          <div
                            className="w-50-pct mg-auto p-1 bg-white input-put"
                            style={{
                              height: "69vh",
                              overflowY: "scroll",
                              overflowX: "hidden",
                            }}
                          >
                            <span className="block text-32-px text-center p-0-5">
                              {api.api_name}
                            </span>
                            {fields.map((field, index) => {
                              // if (field?.title?.visible === false) {
                              //   return null;
                              // }
                              if (
                                field.apiDelete &&
                                Object.values(field.apiDelete).length > 0
                              ) {
                                API_DELETE.current = field.apiDelete.api_detail;
                              }
                              if (field?.editor === true) {
                                return (
                                  <>
                                    <div className="row justify-content-center">
                                      <label for="name" className="col-md-6">
                                        {field?.title?.content ||
                                          field.field_name}
                                        {!field.NULL && (
                                          <span style={{ color: "red" }}>
                                            {" "}
                                            *
                                          </span>
                                        )}
                                      </label>
                                    </div>
                                    <div className="row justify-content-center">
                                      <div className="col-md-6">
                                        <EditorToolbar
                                          id={`toolbar-${index}`}
                                        />
                                        <ReactQuill
                                          theme="snow"
                                          value={
                                            initialData[field.fomular_alias]
                                              ? initialData[field.fomular_alias]
                                              : ""
                                          }
                                          onChange={(e) =>
                                            changeTrigger(field, e)
                                          }
                                          modules={{
                                            ...modules,
                                            toolbar: {
                                              ...modules.toolbar,
                                              container: `#toolbar-${index}`,
                                            },
                                          }}
                                          formats={formats}
                                        />
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                              return field?.title?.visible !== false ? (
                                <div key={field.field_id}>
                                  {field.DATATYPE == "PHONE" ? (
                                    <DataPhone
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      onPhoneError={handlePhoneError}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "VARCHAR" ? (
                                    <Varchar
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "CHAR" ? (
                                    <Char
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "TEXT" ? (
                                    <Text
                                      selectOption={false}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={(...props) => {
                                        changeTrigger(...props, field);
                                      }}
                                      setDefaultValues={setDefaultValues}
                                      textarea={field.textarea}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                      setData={setData}
                                      param={params}
                                      PUBLIC_API={PUBLIC_API}
                                      GET_DATA={GET_DATA}
                                      isBulkUpdate={isBulkUpdate}
                                      removeSelected={removeSelected}
                                      setDataDelete={setDataDelete}
                                      isDataDelete={isDataDelete}
                                    />
                                  ) : null}
                                  {field.DATATYPE == "INT" ||
                                  field.data_type == "BIG INT" ? (
                                    <Int
                                      selectOption={false}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "INT UNSIGNED" ||
                                  field.data_type == "BIG INT UNSIGNED" ? (
                                    <Int
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      unsigned={true}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DATE" ? (
                                    <DateInput
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "EMAIL" ? (
                                    <DataEmail
                                      selectOption={true}
                                      readOnly={true}
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      onEmailError={handleEmailError}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "TIME" ? (
                                    <TimeInput
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DATETIME" ? (
                                    <DateTimeInput
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DECIMAL" ? (
                                    <Decimal
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "DECIMAL UNSIGNED" ? (
                                    <Decimal
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      unsigned={true}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "BOOL" ? (
                                    <Bool
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                  {field.DATATYPE == "FILE" ? (
                                    <FileImageUpdate
                                      table={
                                        tables.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      changeTrigger={changeTrigger}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                </div>
                              ) : null;
                            })}
                            {/* <div className="m-t-1">
                                                  <div className="p-1">
                                                      <div className="button-wrapper">
                                                          <button onClick={submit} className="w-max-content p-0-5 p-l-1 p-r-1 shadow-blur shadow-hover bg-theme-color no-border block text-16-px white pointer shadow-blur shadow-hover">Lưu lại</button>
                                                      </div>
                                                      <div className="button-wrapper">
                                                          <button  className="w-max-content p-0-5 p-l-1 p-r-1 shadow-blur shadow-hover bg-theme-color no-border block text-16-px white pointer shadow-blur shadow-hover">Quay về</button>
                                                      </div>
                                                  </div>
                                              </div> */}
                          </div>
                          <div class="row justify-content-center">
                            <div class="col-md-6">
                              <div class="mt-2 d-flex justify-content-end">
                                <button
                                  type="button"
                                  style={{ minWidth: "105px" }}
                                  onClick={submit}
                                  class="btn btn-success mr-2"
                                >
                                  {/* thinh this is where to fixx */}
                                  {lang["btn.update"]}
                                </button>
                                <button
                                  type="button"
                                  style={{ minWidth: "105px" }}
                                  onClick={() => goToHomePage()}
                                  data-dismiss="modal"
                                  class="btn btn-danger"
                                >
                                  {lang["btn.close"]}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div class="table_section padding_infor_info p-0">
              <div class="row column1">
                <div class="form-group col-lg-4"></div>
                <div class="col-md-12 col-lg-12">
                  <div class="d-flex align-items-center mb-1"></div>
                </div>
                {tables.length > 0 ? (
                  <>
                    <div class="col-md-12">
                      <div
                        className="w-50-pct mg-auto p-1 bg-white"
                        style={{
                          height: "70vh",
                          overflow: "auto",
                        }}
                      >
                        <span className="block text-32-px text-center p-0-5">
                          {api.api_name}
                        </span>
                        {fields.map((field, index) => {
                          if (field?.title?.visible === false) {
                            return null;
                          }
                          if (field?.editor === true) {
                            return (
                              <>
                                <div className="row justify-content-center">
                                  {" "}
                                  <label for="name" className="col-md-6">
                                    {field?.title?.content || field.field_name}
                                    {!field.NULL && (
                                      <span style={{ color: "red" }}> *</span>
                                    )}
                                  </label>
                                </div>
                                <div className="row justify-content-center">
                                  <div className="col-md-6">
                                    <EditorToolbar id={`toolbar-${index}`} />
                                    <ReactQuill
                                      theme="snow"
                                      value={
                                        initialData[field.fomular_alias]
                                          ? initialData[field.fomular_alias]
                                          : ""
                                      }
                                      onChange={(e) => changeTrigger(field, e)}
                                      modules={{
                                        ...modules,
                                        toolbar: {
                                          ...modules.toolbar,
                                          container: `#toolbar-${index}`,
                                        },
                                      }}
                                      formats={formats}
                                    />
                                  </div>
                                </div>
                              </>
                            );
                          }
                          return (
                            <div key={field.field_id}>
                              {field.DATATYPE == "PHONE" ? (
                                <DataPhone
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  onPhoneError={handlePhoneError}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "VARCHAR" ? (
                                <Varchar
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "CHAR" ? (
                                <Char
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "TEXT" ? (
                                <Text
                                  selectOption={false}
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "INT" ||
                              field.data_type == "BIG INT" ? (
                                <Int
                                  selectOption={false}
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "INT UNSIGNED" ||
                              field.data_type == "BIG INT UNSIGNED" ? (
                                <Int
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  unsigned={true}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "DATE" ? (
                                <DateInput
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "EMAIL" ? (
                                <DataEmail
                                  selectOption={true}
                                  readOnly={true}
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  onEmailError={handleEmailError}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "TIME" ? (
                                <TimeInput
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "DATETIME" ? (
                                <DateTimeInput
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "DECIMAL" ? (
                                <Decimal
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "DECIMAL UNSIGNED" ? (
                                <Decimal
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  unsigned={true}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "BOOL" ? (
                                <Bool
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                              {field.DATATYPE == "FILE" ? (
                                <FileImageUpdate
                                  table={
                                    tables.filter(
                                      (tb) => tb.id == field.table_id
                                    )[0]
                                  }
                                  related={relatedTables}
                                  field={field}
                                  changeTrigger={changeTrigger}
                                  defaultValue={
                                    initialData[field.fomular_alias]
                                  }
                                />
                              ) : null}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div class="modal-footer w-100">
                      <div class="mt-2 d-flex justify-content-end">
                        <button
                          type="button"
                          style={{ minWidth: "105px" }}
                          onClick={submit}
                          class="btn btn-success mr-2"
                        >
                          {/* thinh this is where to fixx */}
                          {lang["btn.update"]}
                        </button>
                        <button
                          type="button"
                          style={{ minWidth: "105px" }}
                          onClick={handleCloseModal}
                          data-dismiss="modal"
                          class="btn btn-danger"
                        >
                          {lang["btn.close"]}
                        </button>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
